//This file is automatically rebuilt by the Cesium build process.
export default "bool czm_isZeroMatrix(mat4 matrix)\n\
{\n\
return matrix == mat4(0.0);\n\
}\n\
";
